<template>
    <div>
        <JobsOccupationsResume
            :jobs="value.perimeter_jobs"
            :occupations="value.perimeter_occupations"
            :displayWishes="false"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <vs-row v-if="resource.skills.length" class="checkboxes-container mt-10">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
<!--                <label>Toutes les compétences</label>
                <vs-switch v-model="resource.allSkills" name="showAllSkills" class="ml-2" />-->

                <template v-if="typeForm !== 'creation' && typeForm !== 'poursuite'">
                    <label class="ml-20">Affichage :</label>
                    <vs-radio
                        v-model="displayMode"
                        vs-name="radios-occSkill-display"
                        id="radio-occSkill-display-table"
                        class="ml-2"
                        vs-value="table"
                    >
                        Tableau
                    </vs-radio>
                    <vs-radio
                        v-model="displayMode"
                        vs-name="radios-occSkill-display"
                        id="radio-occSkill-display-graphic"
                        class="ml-2"
                        vs-value="graphic"
                    >
                        Graphique
                    </vs-radio>
                </template>
            </vs-col>
            
<!--            <vs-col vs-w="2">
                <vs-button 
                    color="primary"
                    type="border"
                    class="ml-5"
                    icon-pack="feather"
                    icon="icon-refresh-cw"
                    v-tooltip="`Remplacer les données avec la dernière sauvegarde`"
                    @click="resetFromLastRatingClickHandle"
                >
                    &lt;!&ndash; Regénérer le pré-remplissage &ndash;&gt;
                    Dernière sauvegarde
                </vs-button>
            </vs-col>-->
            
            <vs-col vs-w="8">
                <!-- <vs-row>
                    <vs-col class="font-weight-bold">
                        Comparer avec les évaluations ci-dessous sélectionnées à l'étape Périmètre
                    </vs-col>
                </vs-row> -->
                <vs-row class="mt-2">
                    <vs-col vs-w="3" class="mt-2" v-if="!isValidationOrConsultation">
                        <vs-checkbox
                            v-model="suggestionFromOccupationSkills"
                            name="checkboxSuggestionFromOccupationSkills"
                            :disabled="!hasOccupationSkills"
                            v-tooltip="{
                                content: 'Pré-remplissage automatique des compétences lié à l\'évaluation des savoir-faire appelant ces compétences',
                                placement: 'top-start',
                            }"
                        >
                            Suggestion de pré-remplissage
                        </vs-checkbox>
                    </vs-col>
                    <vs-col vs-w="4">
                        <vs-checkbox
                            v-if="hasPersonals"
                            v-model="comparePortalPersonal"
                            name="checkboxComparePortalPersonal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_0">|</span>
                            </label>
                            Auto-évaluation Portail {{ hasPersonals ? `du ${this.formatDate(resource.personals[0].rating_date)}` : '' }}
                        </vs-checkbox>
                    </vs-col>
                    <vs-col vs-w="5">
                        <vs-checkbox
                            v-if="hasExternals"
                            v-model="comparePortalExternal"
                            name="checkboxComparePortalExternal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_1">|</span>
                            </label>
                            {{ resource.externals[0].eval_type }} {{ `du ${this.formatDate(resource.externals[0].rating_date)}` }}
                        </vs-checkbox>
                        <vs-checkbox
                            v-if="hasTwoExternals"
                            v-model="comparePortalSecondExternal"
                            name="checkboxComparePortalSecondExternal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_2">|</span>
                            </label>
                            {{ resource.externals[1].eval_type }} {{ `du ${this.formatDate(resource.externals[1].rating_date)}` }}
                        </vs-checkbox>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <div v-else-if="!loading" class="not-data-table vs-table--not-data">Il n'y a aucune compétence à évaluer</div>

        <Rating-Manager
            v-if="displayMode === 'table' && (resource.skills.length || loading)"
            name="skills"
            :type-form="typeForm"
            v-model="resource.skills"
            :show-hidden="resource.allSkills"
            :col1="{label: 'Compétence', value: 'title', title: 'description', chip: true, chipColor: 'color'}"
            :col2="{label: 'Catégorie', value: 'category_name'}"
            :loading="loading"
            :skill-review="skillReview"
        />

        <div v-else-if="displayMode === 'graphic'" class="chart main">
            <Rating-Chart
                :employee="value.employee"
                class="main-chart"
                :options="chart.options"
                :chart-data="chart.data"
            />
        </div>

    </div>
</template>

<script>
import JobsOccupationsResume from "../JobsOccupationsResume";
import RatingManager from '../RatingManager';
import RatingChart from "@components/app/RatingChart";
import ratingService from "@components/services/ratings";
import ratingChartsHelper from "@/mixins/ratingChartsHelper";

export default {
    components: {
        JobsOccupationsResume, RatingManager, RatingChart
    },
    mixins: [ratingChartsHelper],
    props: {
        typeForm: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        adminSkills: {
            type: Object,
            required: true
        },
        colors: {
            type: Array,
            required: true
        },
        skillReview: {
            type: Boolean,
            required: true
        },
        jobColors: {
            type: Array,
            required: true
        },
        occupationColors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            log: console.log,
            resource: {
                skills: [],
                allSkills: true
            },
            loading: true,
            displayMode: 'table',
            comparePortalPersonal: false,
            comparePortalExternal: false,
            comparePortalSecondExternal: false,
            suggestionFromOccupationSkills: false,
            comparePortalPersonalID: null,
            comparePortalExternalID: null,
            comparePortalSecondExternalID: null,
            firstPortalChecked: null,
            configChanged: false,
        };
    },
    created() {
        this.loading = true;
        this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null
        this.initResource();
        this.loadDefaultRatings();

        if (this.isValidationOrConsultation) {
            this.displayMode = 'graphic'
        }
    },
    computed: {
        isValidationOrConsultation() {
            return this.typeForm === 'consultation' || this.typeForm === 'validation'
        },
        chart() {
            return {
                data: {
                    labels: this.resource.skills.map(s =>
                        this.adminSkillById(s.admin_skill_id)
                            ? this.adminSkillById(s.admin_skill_id).title
                            : ""
                    ),
                    datasets: this.generateDatasets([this.resource.skills])
                },
                options: this.getChartOptions()
            };
        },
        hasExternals() {
            return this.resource.externals && this.resource.externals.length > 0
        },
        hasTwoExternals() {
            return this.resource.externals && this.resource.externals.length > 1
        },
        hasPersonals() {
            return this.resource.personals && this.resource.personals.length > 0
        },
        hasOccupationSkills() {
            return true
        }
    },
    watch: {
        resource: {
            handler: function(val) {

                let data = window._.cloneDeep(this.value);
                data.skills = val.skills
                data.allSkills = val.allSkills

                this.$emit('input', data);
            },
            deep: true
        },
        comparePortalPersonal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.personals[0].id;
            }
            if (!value && this.firstPortalChecked === this.resource.personals[0].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalPersonalID = value ? this.resource.personals[0].id : null
            this.loadDefaultRatings();
        },
        comparePortalExternal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.externals[0].id;
            }
            if (!value && this.firstPortalChecked === this.resource.externals[0].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalExternalID = value ? this.resource.externals[0].id : null
            this.loadDefaultRatings();
        },
        comparePortalSecondExternal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.externals[1].id;
            }
            if (!value && this.firstPortalChecked === this.resource.externals[1].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalSecondExternalID = value ? this.resource.externals[1].id : null
            this.loadDefaultRatings();
        },
        suggestionFromOccupationSkills: function(value) {
            console.log('this.resource.hasInternalRatings', this.resource.hasInternalRatings)
            if (!this.resource.hasInternalRatings) {
                if (value) {
                    this.firstPortalChecked = -1;
                    //this.uncheckAllPortals();
                }
                if (!value) {
                    this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                    this.uncheckAllPortals();
                }
            }
            this.configChanged = true;
            this.loadDefaultRatings();
        }
    },
    methods: {
        isFirstChecked() {
            return this.firstPortalChecked == null
        },
        uncheckAllPortals() {
            this.resource.skills = [];
            this.comparePortalPersonal = false;
            this.comparePortalPersonalID = null;
            this.comparePortalExternal = false;
            this.comparePortalExternalID = null;
            this.comparePortalSecondExternal = false;
            this.comparePortalSecondExternalID = null;
        },

        initResource() {
            this.resource = window._.cloneDeep(this.value);
        },

        adminSkillById(id) {
            if (this.adminSkills.data.length == 0) {
                return;
            }
            return this.adminSkills.data.find(s => s.id == id);
        },

        loadDefaultRatings() {

            let start                                 = Date.now();
            var employee_rating                       = window._.cloneDeep(this.value);
                employee_rating.skills                = this.resource.skills;
                employee_rating.perimeter_occupations = null;
                employee_rating.perimeter_jobs        = null;
                employee_rating.externals             = employee_rating.externals?.map(o => o.id) || [];
                employee_rating.personals             = employee_rating.personals?.map(o => o.id) || [];
                employee_rating.skill_review          = this.skillReview

            window
                .axios({
                    method: "post",
                    url: `/api/gestion/employees/${this.value.employee.id}/ratings/default-skills`,
                    params: {
                        comparePortalPersonal: this.comparePortalPersonal,
                        comparePortalExternal: this.comparePortalExternal,
                        comparePortalSecondExternal: this.comparePortalSecondExternal,
                        comparePortalPersonalID: this.comparePortalPersonalID,
                        comparePortalExternalID: this.comparePortalExternalID,
                        comparePortalSecondExternalID: this.comparePortalSecondExternalID,
                        firstPortalChecked: this.firstPortalChecked,
                        suggestionFromOccupationSkills: this.suggestionFromOccupationSkills,
                        configChanged: this.configChanged,
                    },
                    data: employee_rating,
                })
                .then(response => {
                    this.resource.skills = this.formatDefaultRatings(response.data);
                    this.loading = false;
                    this.configChanged = false;

                    console.info('=> Chargement des compétences depuis API : ' + (Date.now() - start) + 'ms');
                })
                .catch(err => {
                    this.notifyError(err, `Une erreur est survenue`);
                    this.loading = false;
                    this.configChanged = false;
                });
        },

        resetFromLastRatingClickHandle() {
            
            this.$swal({
                //title: `Regénérer le pré-remplissage ?`,
                //text: "Attention, les notes vont être recalculées.",
                title: `Remplacer par la dernière sauvegarde ?`,
                text: "Attention, les courantes seront perdues.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Je confirme",
                cancelButtonText: "J'annule"
            }).then(result => {

                if (result.value) {
                    this.resource.skills = [];
                    this.loadDefaultRatings();
                }
            });
        },

        generateDatasets(ratings) {
            let NonMesuredLevel = 0;
            let datasets = [];
            if (this.ratingSettings.NonMesuredLevel !== null) {
                NonMesuredLevel = this.ratingSettings.NonMesuredLevel;
            }

            const date = this.$moment(this.resource.rating_date).format("l");

            datasets.push({
                label: `${this.resource.skill_review ? this.skillRatingNames.singular : this.projectNames.singular} du ${date}`,
                fill: true,
                ...this.getRatingColorsBySlug(this.resource.skill_review ? 'skill-review-0' : 'pp-0'),
                pointBorderColor: "#fff",
                data: this.showedSkillsNotes(this.resource.skills, NonMesuredLevel, "note"),
                levels: this.showedSkillsNotes(this.resource.skills, NonMesuredLevel, "label")
            });

            return datasets;
        },

        showedSkillsNotes(skills, NonMesuredLevel, type) {
            return skills.map(s =>
                this.ratedSkillNote(s, NonMesuredLevel, type)
            );
        },

        ratedSkillNote(s, NonMesuredLevel, type) {
            if (type === "note") {
                return this.noteById(s.level) || NonMesuredLevel;
            }

            return this.levelLabelById(s.level) || "Non mesuré";
        },

        getChartOptions() {
            return {
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: `Compétences`
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        title: function(tooltipItem, data) {
                            return data.labels[tooltipItem[0].index];
                        },
                        label: (tooltipItem, data) => {
                            const label =
                                data.datasets[tooltipItem.datasetIndex].label;
                            const value =
                                label != "Montée en compétences"
                                    ? data.datasets[tooltipItem.datasetIndex]
                                          .levels[tooltipItem.index]
                                    : null;
                            return value ? `${label}: ${value} ` : `${label}`;
                        }
                    },
                    filter: x => x.yLabel >= 0
                },
                scale: {
                    pointLabels: {
                        callback: function(value, index, values) {
                            // if more than 25 values, display the top label with space under and bottom label with space above
                            if (values.length < 25) {
                                return value;
                            } else {
                                if (index == 0) {
                                    return [value, [" "]];
                                } else if (
                                    values.length % 2 == 0 &&
                                    index == values.length / 2
                                ) {
                                    return [" ", [value]];
                                } else {
                                    return value;
                                }
                            }
                        }
                    },
                    ticks: {
                        min: this.ratingSettings
                            ? this.ratingSettings.RadarCenter
                            : -1,
                        max: 3,
                        stepSize: 1,
                        display: false
                    }
                }
            };
        },

        formatDefaultRatings(ratings) {
            let formatedRatings = [];

            if (ratings.length > 0) {
                ratings.forEach((item) => {
                    item.color = this.getColorFor('skill', item.category_id);
                    formatedRatings.push(item)
                })
            }

            return formatedRatings;
        }
    }
};
</script>


<style lang="scss" scoped>
.chart {
    &.main {
        height: 750px;
        position: relative;
        max-width: 750px;
        margin-left: auto !important;
        margin-right: auto !important;
        @media screen and (max-width: 750px) {
            width: 100%;
            height: 400px;
        }
    }

    .main-chart {
        height: 100%;

        > #radar-chart {
            height: 100%;
        }
    }
}

.other_level {
    font-weight: bold;
    font-size: 1.7rem;

    .other_level_type_0 {
        color: #FF9800;
    }
    .other_level_type_1 {
        color: #4377DF;
    }
    .other_level_type_2 {
        color: #72BB80;
    }
}
</style>
